import Matter from "matter-js";
import { AudioManager, ITrack, Track } from "../../AudioManager";
import { ISystemContext } from "../../Context/SystemContext";
import { LogGroup, Size, Scale, SetStyles, AddMouseDownListener, Log, Safe, shuffle, CreateSpineResources } from "../../MyHelpers";
import { MyVideo } from "../../MyVideo";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { VideoResource2 } from "../../ResourceManager/VideoResource";
import { JackpotDisplayType, Presentation, Settings } from "../../Settings";
import { ZIndex } from "../../ZIndex";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { ITransition } from "./ITransition";
import { ITransitionParams } from "./ITransitionFactory";
import { PixiSprite } from "../Sprite/PixiSprite";
import * as PIXI from 'pixi.js'
import { RegisterPixi, UnregisterPixi } from "../../PixiDebug";
import { IInterval } from "../../Context/Interval";
import { TweenMax } from "gsap";
import * as matterwrap from "matter-wrap"
import { FrontendErrorCode } from "../../api";
import { service } from "../../services";
import { element } from "svelte/internal";
import { ISkeletonData, Spine } from "pixi-spine";
import { ITransitionParamsPIXIAPP } from "./ITransitionFactoryPIXIAPP";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { PixiSpriteResource } from "../../ResourceManager/PixiSpriteResource";



Matter.use('matter-wrap');
// or
Matter.use(matterwrap);


interface objectScene {
    animatedSprite: PIXI.AnimatedSprite,
    particle: Matter.Body,    
}


export enum TransitionPIXITypeStyle {
    default = "default",
    gameStyle = "gameStyle",
    settingsStyle = "settingsStyle",
    imageStyle = "imageStyle",
}

export class VideoSpriteTransitionParticlesPIXIFadeInFadeOut implements ITransition {

    protected systemContext: ISystemContext = null;
    protected params: ITransitionParamsPIXIAPP = null;

    protected view: HTMLElement = null;
    protected audio: AudioManager = null;
    protected resid: ResourceIdentifier = null;
    protected logGroup: LogGroup = null;
    protected gameName: string = null;
    //protected TitleSpriteTransition: CanvasSprite = null;
    //protected spriteResource: SpriteResource;
    //protected videoResource: VideoResource2;
    //protected track: ITrack;
    protected nameResource: string;
    protected fadeOut: boolean;
    protected particleSpriteResource: PixiSprite;
    protected restoreWebGlInterval: IInterval = null;
    //protected sceneObjectsTransition: objectScene[] = [];

    public onTransitionStart: () => void = null;
    public onTransitionEnd: () => void = null;

    //protected engine: Matter.Engine = null;
    //protected render: Matter.Render = null;
    //always by defaut needs disable because use more performance for use 2 canvas at same time 
    protected debugerMatter: boolean = false;
    protected debugerMatterBackgroundColor: string = "rgba(0, 0, 0, 0.5)";
    protected viewMatterPIXICanvasSize = new Size(Scale.W(1920), Scale.H(1080 * Settings.Screens));
    //protected particleLeftInterfal: IInterval = null
    //protected particlesTransitionSpawn: IInterval = null;

    protected fadeInParticleIndex = 0;
    protected startTimeoutFideOut : IInterval = null;
    protected startTimeFadeIn : IInterval = null;

    protected stage: PIXI.Container = null;
   // protected totalParticles : number = 200;
   protected titleTexture :PIXI.Texture[]  = [];

    public constructor(params: ITransitionParamsPIXIAPP) {
        this.params = params;
        this.resid = params.resid;
        this.audio = params.audio;
        this.logGroup = params.logGroup
        this.gameName = params.gameName;
        this.systemContext = params.systemContext;
        //this.spriteResource = params.spriteResource;

        //if(params.spriteResource != null)
       
        //this.track = params.soundResource;
        //this.videoResource = params.videoResource;
        //this.nameResource = params.nameResource;
        this.fadeOut = params.fadeOut;
        

     
        this.startTimeoutFideOut = this.params.systemContext.TimingContext().CreateTimeout("startTimeoutFideOut", 2800, () => {
            TweenMax.to(this.view, 1, {
                autoAlpha: 0, display: "none",
                onStart: () => {
                    this.OnTransitionEnded();
                }, onComplete: () => {
                   //this.TitleSpriteTransition.View().style.display = "none";
                    //setTimeout(() => {
                        if(this.TitlePIXIAnimatedSprite != null) this.TitlePIXIAnimatedSprite.alpha = 0;
                        if(this.titleSpine != null){                            
                            this.titleSpine.visible = false;
                        }
                        this.DestroyTransitionPixi();
                    //}, 500);
                }
            });
        });

        
        this.startTimeFadeIn = this.params.systemContext.TimingContext().CreateInterval("startTimeFadeIn", 10, () => {
            let groupSize = 5 * Settings.Screens;

            for (let indexGroup = 0; indexGroup < groupSize; indexGroup++)
            {
                if (this.fadeInParticleIndex >= this.arrayParticles.length)
                {
                    console.log(`Stop fade in, particles: ${this.fadeInParticleIndex}`);
                    this.fadeInParticleIndex = 0;
                    this.startTimeFadeIn.Stop();
                    if(this.TitlePIXIAnimatedSprite != null){
                        this.TitlePIXIAnimatedSprite.alpha = 1;
                        this.TitlePIXIAnimatedSprite.play();
                    } 
                    if(this.titleSpine != null){
                        this.titleSpine.visible = true;
                        this.titleSpine.state.setAnimation(0,"idle",false);
                    }
                    this.params.audio.Play(this.resid.ScopedResourceName("TitleTransition-Audio"));
                    break;
                }


                //this.arrayParticles[this.fadeInParticleIndex].parent.setChildIndex(this.arrayParticles[this.fadeInParticleIndex], this.fadeInParticleIndex);
                //this.arrayParticles[this.fadeInParticleIndex].scale.set(1 + Math.random()); //scale 1 to 2 randomly (random gives numbers between 0 and 1)
                this.arrayParticles[this.fadeInParticleIndex].alpha = 1;

                this.fadeInParticleIndex++;
            }
        });
    }
    ViewPIXIAPP(): PIXI.Container {
        return this.stage;
    }

    public CreateTransitionPixi (app: PIXI.Container){
        this.stage = app;
        this.Create();
    };

    public DestroyTransitionPixi () {
        this.Destroy()
    };


    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        if (this.params.bonusName == "FreeGameBonus") {
            //create Title Freegames Spine
            resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/FreeGamesBonusTitle/FreeGamesBonusTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleJson`)));
            resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/FreeGamesBonusTitle/FreeGamesBonusTitle.json`, ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleAtlas`)));
            //Prepare Sound Transition Title 
            this.params.audio.AddTrack(new Track(this.params.bonusCommonPath + "resources/tracks/freegame" + Settings.audioFormat, this.resid.ScopedResourceName("TitleTransition-Audio")));
        }
        else {
            this.params.audio.AddTrack(new Track(this.params.bonusCommonPath + "resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/tracks/" + Settings.JackpotDisplayType + Settings.audioFormat, this.resid.ScopedResourceName("TitleTransition-Audio")));
        }

        if (!globalThis.jackpotDisplayGlobal.GetSpineSkeleton() && this.params.bonusName != "FreeGameBonus") resourceManager.AddGlobal(new SpriteResource(this.params.bonusCommonPath + "resources/HoldAndSpin/resources/VideosBackgroundResources-Transition/" + Settings.JackpotDisplayType + "/" + Settings.JackpotDisplayType + "_Transition", ResourceIdentifier.Global.Add("TitleTransition").Add(this.params.bonusName), true, LogGroup.Global.Add("TitleTransition").Add(this.params.bonusName), true))

            resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle-Transition`, this.resid.Add("Partitle-Transition").Shared(), true, this.logGroup.Add("Partitle-Transition"), true));
        
    };
    protected particleTexture: PIXI.Texture[]  = [];
   // protected particleBoundingBox = [];
    protected textureSize : Size = new Size ( 0 , 0 );
    protected skelentonDataSpine : ISkeletonData = null;
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        if (!globalThis.jackpotDisplayGlobal.GetSpineSkeleton()) {
            let spriteResource = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("TitleTransition").Add(this.params.bonusName))
            for (let decodedFrames of spriteResource?.sprite.shared.decodedFrames) {
                // baseTexture.width = this.textureSize.width;
                //baseTexture.height = this.textureSize.height;

                let symbolTexture = PIXI.Texture.from(decodedFrames);
                this.titleTexture.push(symbolTexture);
            }
        }
        //its using title for jackpot into spine version.
        else {
            //check which bonus was creating the transition for change the title spine.
            if (this.params.bonusName == "FreeGameBonus") {
                let spineTextureJson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`FreeGamesBonusTitleJson`));
                let spineAsset = await PIXI.Assets.load(spineTextureJson.path);
                this.skelentonDataSpine = spineAsset.spineData;
            } else {
                this.skelentonDataSpine = globalThis.jackpotDisplayGlobal.GetSpineSkeleton();
            }
        }


        


        let sprite: PixiSprite = resourceManager.Get<PixiSpriteResource>(this.resid.Add(`Partitle-Transition`).Shared()).sprite;
        let textures: PIXI.Texture[] = [];
        //let boundingBoxScaledWidth = Scale.W(this.params.boundingBox.imgwidth);
        //let needScalingTexture = Math.abs(sprite.DecodedFrames[0].width - boundingBoxScaledWidth) > 3;



        this.textureSize.Width = Scale.W(sprite?.DecodedFrames[sprite.DecodedFrames.length -1].width);
        this.textureSize.Height = Scale.H(sprite?.DecodedFrames[sprite.DecodedFrames.length -1].height);

        for (let decodedFrames of sprite?.DecodedFrames)
        {
            let symbolTexture = PIXI.Texture.from(decodedFrames);
            
            symbolTexture.baseTexture.width = this.textureSize.Width;
            symbolTexture.baseTexture.height = this.textureSize.Height;

            textures.push(symbolTexture);
        }
        
        this.particleTexture = textures;
        //this.LoadTitleTransition(resourceManager);
    };

    protected created: boolean = false;
    /** use for create App Pixi.js*/
    public Create() {
        this.created = true;
        {
            this.InternalCreate();
        }
        // catch (ex) {
        //     this.restoreWebGlInterval.Start();
        // }
    }
    /** use for create pixi and registred for dont create multi times */
    public InternalCreate() {
        if (!this.created)
		{
			Log.Error(this.logGroup, `Create(): app not null, don't recreate`);
			return;
		}


        // // Log.Debug(this.logGroup, `Create(): creating reels`);
        // this.app = new PIXI.Application({
        //     width: this.viewMatterPIXICanvasSize.width,
        //     height: this.viewMatterPIXICanvasSize.height,
        //     backgroundAlpha: 0,
        //     // backgroundColor : 0x0A0A0A,
            
        // });       
        // this.app.stage.name = "PIXIContainer";
        // this.app.stage.accessibleChildren = true;
        // this.app.stage.accessible = true
        // this.app.stage.sortableChildren = true;        
        // this.app.view.style.bottom = Scale.ZERO_PX;
        // this.app.view.style.zIndex = ZIndex.BonusTransition + "";

     
        this.CreateParticlesSprites();
        
    }

    protected webglcontextlost() {
        console.log(this.resid.ID() + " context lost");
        // try recover right now, or start timer to try recover later
        let success = this.tryRecoverWebglContext();
        if (success) {
            // all good
            return;
        }

        // error recovering, start timer
        this.restoreWebGlInterval.Start();
    }

    protected recoverCount: number = 0;
    protected recoverFailCount: number = 0;
    protected readonly maxRecoverFailCount = 5;
    protected tryRecoverWebglContext(): boolean {
        if (!this.created) {
            this.restoreWebGlInterval.Stop();
            this.recoverFailCount = 0;

            // app not created, don't care
            return true;
        }

        console.log(this.resid.ID() + " trying to recover");
           void service.api.frontendError(FrontendErrorCode.WebGLContextRecovering, `${this.resid.ID()}`);
        try {
               void service.api.frontendError(FrontendErrorCode.WebGLDestroy, `${this.resid.ID()}`);
            this.InternalDestroy();
               void service.api.frontendError(FrontendErrorCode.WebGLDestroySuccess, `${this.resid.ID()}`);
        }
        catch (ex) {
               void service.api.frontendError(FrontendErrorCode.WebGLDestroyError, `${this.resid.ID()}: ${ex.toString()}`);
        }

        try {
            // Log.Debug(this.logGroup, `tryRecoverWebglContext() ${this.resid.ID()} recreating`);
               void service.api.frontendError(FrontendErrorCode.WebGLCreate, `${this.resid.ID()}`);
            this.InternalCreate();

            // all fine, stop timer
            this.restoreWebGlInterval.Stop();
            console.log(this.resid.ID() + " recover success");

            this.recoverCount++;
            this.restoreWebGlInterval.Stop();
            this.recoverFailCount = 0;

               void service.api.frontendError(FrontendErrorCode.WebGLCreateSuccess, `${this.resid.ID()}`);
               void service.api.frontendError(FrontendErrorCode.WebGLContextRecovered, `${this.resid.ID()}, recover count: ${this.recoverCount}`);

            return true;
        }
        catch (ex) {
               void service.api.frontendError(FrontendErrorCode.WebGLCreateError, `${this.resid.ID()}, ${ex.toString()}`);

            console.log(this.resid.ID() + " error recovering", ex);

            // prevent spamming the backend
            if (this.recoverFailCount < this.maxRecoverFailCount) {


                if (ex.message.toLowerCase().includes("this browser does not support webgl")) {
                       void service.api.frontendError(FrontendErrorCode.WebGLNotSupported, `${this.resid.ID()}, error: ${ex.toString()}`);
                }
                else {
                       void service.api.frontendError(FrontendErrorCode.WebGLRecoverError, `${this.resid.ID()}, error: ${ex.toString()}`);
                }
            }
        }

        return false;
    };


    protected webglcontextlostInstance: () => void = this.webglcontextlost.bind(this);

    /** use for destroy  App Pixi.js if that exist*/
    public Destroy() {        
        this.InternalDestroy();
        this.created = false;
        //this.restoreWebGlInterval.Stop();
    }

    public InternalDestroy()
    {
        //this.updateMatter = false;
        if (!this.created) {
            Log.Debug(this.logGroup, `Destroy() FillingPot: no app, not destroying anything`);
            return;
        }       

        Safe(() =>{
			this.containertransitionViewApp.removeChildren();
			this.containertransitionViewApp.removeFromParent();
		});

        //this.OnDestroyCallback?.();        
    }

    protected arrayParticles : PIXI.AnimatedSprite [] = [];
    // protected arrayRandomSize = [1.15,1.25, 1.45, 1.65];
    // protected arrayRandomSizePercent = [0.10,0.35,0.75,0.99];
    protected containertransitionViewApp = new PIXI.Container();
    protected TitlePIXIAnimatedSprite : PIXI.AnimatedSprite = null;
    protected titleSpine : Spine = null;
    protected CreateParticlesSprites() {

        if (this.stage == null) return



        this.containertransitionViewApp = new PIXI.Container();
        this.containertransitionViewApp.name = "containertransitionViewApp";
        this.containertransitionViewApp.interactive = false;
        this.containertransitionViewApp.interactiveChildren = false;
        this.stage.addChild( this.containertransitionViewApp);
        this.containertransitionViewApp.zIndex = 1;
        this.containertransitionViewApp.parent.setChildIndex(this.containertransitionViewApp, 1);

        

        if (globalThis.jackpotDisplayGlobal.GetSpineSkeleton() != null) {
            this.titleSpine = CreateSpineResources(this.skelentonDataSpine);
            this.titleSpine.visible = false;
            this.titleSpine.y = Settings.ScreenHeight * (Settings.Screens - 1);
            this.containertransitionViewApp.addChild(this.titleSpine);
        }
        else {
            this.TitlePIXIAnimatedSprite = new PIXI.AnimatedSprite(this.titleTexture);
            //this.TitlePIXIAnimatedSprite.x = Settings.ScreenWidth/2;
            this.TitlePIXIAnimatedSprite.y = (Settings.ScreenHeight * (Settings.Screens - 1)) + ( this.TitlePIXIAnimatedSprite.height / 2);
            this.TitlePIXIAnimatedSprite.alpha = 0;
            this.containertransitionViewApp.addChild(this.TitlePIXIAnimatedSprite);
        }
        


        this.arrayParticles = [];

        let index = 0;

        // elements are overlaping by 50% of their size
        let overlap = 0.5;
        let rows = Math.ceil(this.viewMatterPIXICanvasSize.Height / this.textureSize.Height / overlap);
        let cols = Math.ceil(this.viewMatterPIXICanvasSize.Width / this.textureSize.Width / overlap);

        for (let row = 0; row < rows; row++) {
            for (let col = 0; col < cols; col++) {
                let imageSprite = new PIXI.AnimatedSprite(this.particleTexture);
                
                imageSprite.anchor.set(0.5);
                imageSprite.x = col * this.textureSize.Width  * overlap;
                imageSprite.y = row * this.textureSize.Height * overlap;
                imageSprite.alpha = 0; 
                
                this.containertransitionViewApp.addChild(imageSprite);
                this.arrayParticles.push(imageSprite);
                index++;
            }
        }

        // // Move container to the center
        // container.x = Scale.X(33);
        // container.y = Scale.Y(33);
        //this.app.stage.addChild(container);
        this.fadeInParticleIndex = 0;
        shuffle(this.arrayParticles);
        for (let indexGroup = 0; indexGroup < this.arrayParticles.length; indexGroup++)
        {
           

            this.arrayParticles[this.fadeInParticleIndex].parent.setChildIndex(this.arrayParticles[this.fadeInParticleIndex], this.fadeInParticleIndex);
            this.arrayParticles[this.fadeInParticleIndex].scale.set(1 + Math.random()); //scale 1 to 2 randomly (random gives numbers between 0 and 1)
            this.arrayParticles[this.fadeInParticleIndex].alpha = 0;

            this.fadeInParticleIndex++;
        }
    }



    protected started: boolean = false;
    protected categoryWorld : number = 1;
    protected categoryParticleLeft : number = 2;
    protected categoryParticleRight: number = 3;
    public ShowTransiton(): void {
        if (this.started == false) {           
            this.OnTransitionStarted();          
            // TweenMax.to(this.view, 0.8, {
            //     autoAlpha: 1, display: "flex", onComplete: () => {
            //     }
            // });

            
            // set alpha 0 to all particles           
            TweenMax.set(this.view, { autoAlpha: 1, display: "flex" });

            // shuffle and restart
            shuffle(this.arrayParticles);
            this.fadeInParticleIndex = 0;

            this.started = true;
            this.startTimeFadeIn.Restart();
            //this.containertransitionViewApp.parent.setChildIndex(this.containertransitionViewApp,2);
            this.fadeSettings();
        }
    };

    protected fadeSettings() {

        if (this.fadeOut == true) {
           //this.TitleSpriteTransition.View().style.display = "block";                  
            //this.TitleSpriteTransition.Start(false);
            this.startTimeoutFideOut.Start();      
        }
        else {

        }

    }   

    public View(): HTMLElement {
        return this.view
    };

    public OnTransitionStarted() {
        Log.Debug(this.logGroup, "Transition started");
        this.onTransitionStart?.();
    }

    public OnTransitionEnded(): void {
        Log.Debug(this.logGroup, "Transition ended");
        this.started = false;
        this.onTransitionEnd?.();
    }

   // protected updateMatter: boolean = false;
    public Update(): void {    
        //this.TitleSpriteTransition?.Update();
        //this.app?.ticker?.update();
    }

    public OnResize(): void {
        
    }
}
